/* litaeau-product-premium.js — le moteur de la fiche d'achat premium.

   🛑 POURQUOI UN FICHIER. Ce script vivait EN LIGNE dans la section : 54 a 205 Ko
      de JavaScript renvoyes avec chaque page, jamais mis en cache, et relus par le
      navigateur a chaque fiche (audit SEO du 22/09, PERF-07 et PERF-08). En asset
      `defer`, il se telecharge une fois pour toutes les fiches et profite du cache
      de code du navigateur.

   Ce que Liquid lui donnait, la section le pose maintenant sur elle-meme :
     data-pp-sid        l'identifiant de section (les id `pp-*-<sid>`)
     data-pp-titre      le NOM du produit (propriete « Pour » des supplements)
     data-pp-algicide   « matelas » | « ensemble » | vide (conditionneur offert)
     data-pp-poches     1 ou 2 (lits vendus tout configures)
     #pp-var-<sid>      la table des variantes, reduite aux champs lus ici.

   ⚠️ `defer` : le script tourne APRES l'analyse du document, et non plus au fil de
      l'eau juste apres la section. Rien ici ne dependait de cet ordre : les
      ecouteurs du nuancier (`litaeau-coloris`) sont autonomes et differes par
      `setTimeout`, et la barre d'achat se cale sur l'observateur d'intersection.
*/
(function(){
  function initPremium(sec){
  var sid=sec.getAttribute('data-pp-sid');
  var titre=sec.getAttribute('data-pp-titre')||'';
  var algicide=sec.getAttribute('data-pp-algicide')||'';
  var poches=sec.getAttribute('data-pp-poches')||'1';
  var form=document.getElementById('pp-form-'+sid); if(!form) return;
  var root=form.closest('.pp-'+sid)||document;
  /* ⚠️ `product.variants | json` pesait 152 Ko sur le cadre Emma (250 variantes) :
     le script n'en lit que neuf champs (id, title, option1-3, price,
     compare_at_price, available, featured_media.id). La section n'emet plus que
     ceux-la, dans un <script type="application/json"> que ce fichier relit. */
  var variants=[]; try{ variants=JSON.parse((document.getElementById('pp-var-'+sid)||{}).textContent||'[]'); }catch(e){}
  var stage=document.getElementById('pp-stage-'+sid);
  var slides=stage?[].slice.call(stage.querySelectorAll('.gal__slide')):[];
  var thumbs=[].slice.call(document.querySelectorAll('#pp-thumbs-'+sid+' .gal__thumb'));
  var idEl=document.getElementById('pp-id-'+sid), addEl=document.getElementById('pp-add-'+sid);
  var priceEl=root.querySelector('[data-price]'), cmpEl=root.querySelector('[data-compare]');
  function money(c){var cur=((window.Shopify||{}).currency||{}).active||'EUR';var sym=cur==='EUR'?' €':(' '+cur);try{return (c/100).toLocaleString('fr-FR',{minimumFractionDigits:2})+sym;}catch(e){return (c/100)+sym;}}
  /* 🛑 Un identifiant de media qu'aucune diapo ne porte ETEIGNAIT toute la
     galerie : la boucle posait `is-on = (mid de la diapo === mid demande)`
     sur CHAQUE diapo, donc faux partout. La commode arrivait sans aucune
     photo, parce que sa variante par defaut designe son 9e media et que la
     galerie n'en montait que huit. On ne change rien quand la cible n'est
     pas la : garder la photo precedente vaut mieux qu'un cadre vide. */
  function showMedia(mid){ if(mid==null) return;
    var connue = slides.some(function(s){ return String(s.getAttribute('data-mid'))===String(mid); });
    if(!connue) return;
    /* PageSpeed 23/09 : les diapos cachees attendent en `data-src` (chargeur en
       fin de section). Montrer une diapo avant `load` la charge tout de suite. */
    slides.forEach(function(s){ if(String(s.getAttribute('data-mid'))===String(mid) && window.ppCharger) window.ppCharger(s.querySelector('img')); });
    slides.forEach(function(s){s.classList.toggle('is-on',String(s.getAttribute('data-mid'))===String(mid));}); thumbs.forEach(function(t){t.classList.toggle('is-on',String(t.getAttribute('data-mid'))===String(mid));}); }
  /* 🛑 La legende dit ce que la PHOTO montre, pas ce que le client a
     choisi. Akva ne photographie qu'une finition par modele : sans cette
     phrase, un client qui choisit « Hetre teinte » voit un meuble clair et
     n'a aucun moyen de savoir que la photo montre une autre finition. */
  function legenderMedia(mid){
    if(!legende || mid==null) return;
    for(var i=0;i<slides.length;i++){
      if(String(slides[i].getAttribute('data-mid'))!==String(mid)) continue;
      var a = (slides[i].getAttribute('data-alt')||'').trim();
      if(a) legende.textContent = 'Sur la photo : ' + a
        + (a.slice(-1)==='.' ? '' : '.');
      return;
    }
  }
  thumbs.forEach(function(t){t.addEventListener('click',function(){showMedia(t.getAttribute('data-mid'));legenderMedia(t.getAttribute('data-mid'));});});

  /* ─── Plein cadre ou mise en scène ? ─────────────────────────────────────────
     🛑 Le thème ne peut pas regarder les pixels, mais il peut comparer les
        FORMES. Une photo dont le rapport est celui de l'estrade est faite pour
        la remplir : la marge de 1,5 % y devient un liseré clair. Un objet
        découpé, lui, a une forme quelconque et sa marge est voulue.
     On compare donc le rapport de l'image à celui de son cadre : à 4 % près,
     c'est une photo pleine et la marge saute. */
  function ajusterPlein(){
    if(!stage) return;
    var rs = stage.getBoundingClientRect();
    if(!rs.height) return;
    var fCadre = rs.width / rs.height;
    slides.forEach(function(sl){
      var im = sl.querySelector('img');
      /* le pixel d'attente d'une diapo differee (1 x 1) n'a pas la forme de la photo */
      if(!im || im.hasAttribute('data-src') || !im.naturalWidth || !im.naturalHeight) return;
      var f = im.naturalWidth / im.naturalHeight;
      var ecart = Math.abs(f - fCadre) / Math.max(f, fCadre);
      sl.classList.toggle('gal__slide--plein', ecart <= 0.04);
    });
  }
  /* ⚠️ `naturalWidth` vaut 0 tant que l'image n'est pas chargée : on rejoue au
     chargement de chacune, sinon la première visite ne verrait rien. */
  slides.forEach(function(sl){
    var im = sl.querySelector('img');
    /* ⚠️ PageSpeed 23/09 : l'ecouteur se pose TOUJOURS. Une diapo differee porte
       un pixel d'attente deja `complete` ; sans ecouteur, sa vraie photo arrivee
       plus tard ne serait jamais mesuree. */
    if(im){ if(im.complete) ajusterPlein(); im.addEventListener('load', ajusterPlein); }
  });
  ajusterPlein();
  window.addEventListener('resize', ajusterPlein);
  /* Un porteur de variante n'a ni options ni bouton d'achat : seule la galerie vit. */
  if(sec.getAttribute('data-pp-porteur')) return;

  /* ─── Voir ce qu'on vient de choisir ────────────────────────────────────────
     🛑 Choisir une teinte ou une matière ne changeait rien à l'image. Sur une
        tête de lit dont le seul choix visuel EST la couleur, la décision se
        prenait à l'aveugle.

     Resolution en deux temps, du plus vrai au moins precis :
       1. une image du produit dont le `alt` nomme la teinte ou la matiere —
          c'est une vraie photo de CE produit dans CETTE couleur ;
       2. a defaut, la photo du tissu, prise sur le bouton du nuancier.
     Le jour ou les photos par teinte existent, elles gagnent toutes seules.

     ⚠️ On compare en minuscules et sans accents : le `alt` d'une photo est
        ecrit a la main, « Athina 12 » y devient « athina n°12 » ou « Athina12 ».
        Une comparaison stricte ne trouverait jamais rien et la case de choix
        montrerait toujours le tissu, meme quand la vraie photo existe. */
  var slideChoix = stage ? stage.querySelector('.gal__slide--choix') : null;
  var thumbChoix = document.querySelector('#pp-thumbs-'+sid+' .gal__thumb--choix');
  var legende = document.querySelector('#pp-leg-'+sid);

  function aplati(s){
    return (s||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'')
                  .replace(/[^a-z0-9]+/g,' ').trim();
  }
  /* ⚠️ Exiger TOUS les mots ne marche que pour une teinte (« Athina 21 »). Pour
     un choix d'option, le libelle et le texte alternatif ne se recouvrent
     jamais entierement : « 2 grands tiroirs · Placage » contre « Socle Akva Big
     Box : grands tiroirs du sol au cadre ». On score donc les mots DISTINCTIFS,
     et on ne retient que si un seul media gagne — a egalite, changer l'image
     serait un coup de des. */
  var BANALS = {socle:1, akva:1, lit:1, de:1, du:1, la:1, le:1, les:1, en:1, sur:1, un:1, une:1, et:1, au:1, aux:1, vue:1};
  /* 🛑 UN NOMBRE SE COMPARE ENTIER. `indexOf` trouvait « 10 » dans « 100 cm »
     et « haut » dans « haute » : l'alt de la commode a CINQ tiroirs
     (« 100 cm haute a cinq tiroirs ») contenait donc tous les mots de
     « Haut 100 · 10 tiroirs », et passait pour une correspondance EXACTE.
     Un jeton numerique doit etre un mot entier ; le reste garde la souplesse
     du prefixe, qui sert aux accords et aux pluriels. */
  function dedans(a, m){
    if(/^\d+$/.test(m)) return (' '+a+' ').indexOf(' '+m+' ') >= 0;
    return a.indexOf(m) >= 0;
  }
  function mediaQuiMontre(nom){
    var cle = aplati(nom);
    if(!cle) return null;
    var mots = cle.split(' ').filter(function(m){return m.length>1;});
    if(!mots.length) return null;
    /* 🛑 Un NOMBRE ne designe pas une photo. « 25 ou 30 cm » tombait sur le
       Benti parce que son texte alternatif finit par « 25 cm » : la fiche
       montrait un chassis d'aluminium a qui choisissait une hauteur. On jette
       donc les jetons purement numeriques, et on exige DEUX mots distinctifs —
       un seul suffisait a apparier « 2 tiroirs » avec « grands tiroirs ». */
    var forts = mots.filter(function(m){ return !BANALS[m] && !/^\d+$/.test(m); });
    var exact = null, best = null, bestN = 0, exaequo = false;
    slides.forEach(function(s){
      var a = aplati(s.getAttribute('data-alt'));
      if(!a) return;
      if(!exact && mots.every(function(m){ return dedans(a,m); })) exact = s.getAttribute('data-mid');
      var n = forts.filter(function(m){ return dedans(a,m); }).length;
      if(n > bestN){ bestN = n; best = s.getAttribute('data-mid'); exaequo = false; }
      else if(n === bestN && n > 0 && best !== s.getAttribute('data-mid')) exaequo = true;
    });
    if(exact) return exact;
    return (bestN >= 2 && !exaequo) ? best : null;
  }
  /* 🛑 Les photos par teinte NE PEUVENT PAS etre des medias du produit : la
     galerie n'en rend que huit (`product.media limit: 8`), et une tete compte
     jusqu'a 41 teintes. Attachees, les 33 dernieres n'existeraient nulle part a
     l'ecran — et le defaut serait invisible, puisque la fiche resterait belle.
     Elles vivent donc dans les Fichiers de la boutique, et un metachamp
     `custom.images_teintes` dit laquelle montre quelle teinte. */
  var parTeinte = {};
  try { parTeinte = JSON.parse(root.getAttribute('data-img-teintes') || '{}'); } catch(e){}

  function montrerChoix(nom, url){
    if(!slideChoix) return;
    /* 1. la photo du PRODUIT dans cette teinte, si elle existe */
    var direct = parTeinte[nom];
    if(direct){
      var i0 = slideChoix.querySelector('img');
      i0.src = direct.split('?')[0] + '?width=1000';
      i0.alt = nom;
      slideChoix.hidden = false;
      if(thumbChoix){ thumbChoix.hidden = false;
        thumbChoix.querySelector('img').src = direct.split('?')[0] + '?width=160';
        if(slides.indexOf(slideChoix)<0) slides.push(slideChoix);
        if(thumbs.indexOf(thumbChoix)<0){ thumbs.push(thumbChoix);
          thumbChoix.addEventListener('click', function(){ showMedia('choix'); }); }
      }
      showMedia('choix');
      if(legende) legende.textContent = nom;
      return;
    }
    /* 2. un media du produit dont le texte alternatif nomme la teinte */
    var mid = mediaQuiMontre(nom);
    if(mid){ showMedia(mid); if(legende) legende.textContent = nom; return; }
    /* 3. a defaut, la photo du tissu — reelle, mais ce n'est pas le produit */
    if(!url) return;
    var img = slideChoix.querySelector('img');
    /* la vignette du nuancier est petite : on redemande une taille d'estrade */
    img.src = url.split('?')[0] + '?width=1000';
    img.alt = nom;
    slideChoix.hidden = false;
    if(thumbChoix){ thumbChoix.hidden = false;
      thumbChoix.querySelector('img').src = url.split('?')[0] + '?width=160';
      if(slides.indexOf(slideChoix)<0) slides.push(slideChoix);
      if(thumbs.indexOf(thumbChoix)<0){ thumbs.push(thumbChoix);
        thumbChoix.addEventListener('click', function(){ showMedia('choix'); }); }
    }
    showMedia('choix');
    if(legende) legende.textContent = nom + ' — le tissu choisi. La photo du produit dans cette teinte n’existe pas encore.';
  }
  /* Delegation : le nuancier se re-rend quand on change de matiere, donc on
     n'attache rien aux boutons eux-memes. */
  document.addEventListener('click', function(ev){
    if(!ev.target.closest) return;
    var b = ev.target.closest('[data-teinte]');
    if(b && root.contains(b)){
      var im = b.querySelector('img');
      /* PageSpeed 23/09 : une pastille pas encore chargee porte son adresse en
         `data-src` et un pixel `data:` en `src` — on lit la vraie adresse. */
      montrerChoix(b.getAttribute('title') || b.getAttribute('data-teinte'),
                   im ? (im.getAttribute('data-src') || im.currentSrc || im.src) : null);
      return;
    }
    /* 🛑 « Quand je selectionne un socle, ça ne me donne pas la photo adaptee. »
       Le meme mecanisme que pour les teintes vaut pour les OPTIONS : la fiche
       du socle porte six images — un socle plein, un a tiroirs, un big box —
       et choisir « 2 tiroirs · Placage » n'en montrait aucune.
       On cherche donc, parmi les medias du produit, celui dont le texte
       alternatif nomme le choix. Rien trouve : on ne touche pas a l'image,
       plutot que d'en afficher une au hasard. */
    var q = ev.target.closest('.pill[data-val]');
    if(!q || !root.contains(q) || q.hidden) return;
    /* 🛑 LE LIEN EXPLICITE DE LA VARIANTE GAGNE SUR CETTE HEURISTIQUE.
       Mesure du 17/09 sur la commode : choisir « Haut 100 · 10 tiroirs »
       montrait la photo des CINQ tiroirs. La variante etait pourtant reliee au
       bon media ; c'est cet ecouteur qui repassait derriere `refresh()` et
       imposait sa correspondance par texte alternatif.
       L'appariement par mots est un SECOURS, pour les fiches dont les variantes
       ne portent aucune image (les socles, pour qui il a ete ecrit). Des qu'une
       variante dit elle-meme quelle photo la montre, on se tait. */
    try {
      var vExp = findVariant(selected());
      if (vExp && vExp.featured_media && vExp.featured_media.id) return;
    } catch(e) {}
    var val = q.getAttribute('data-val');
    var mid = mediaQuiMontre(val);
    if(mid){ showMedia(mid); if(legende) legende.textContent = val; }
  });
  // options
  var groups=[].slice.call(form.querySelectorAll('.opt__pills'));
  function selected(){return groups.map(function(g){var on=g.querySelector('.pill.is-on');return on?on.getAttribute('data-val'):null;});}
  function findVariant(sel){return variants.filter(Boolean).find(function(v){for(var i=0;i<sel.length;i++){if(sel[i]!=null && v['option'+(i+1)]!==sel[i])return false;}return true;});}

  /* 🛑 30/09 — RIEN N'EST CHOISI D'AVANCE (« on ne doit pas pouvoir commander si toutes les options ne
     sont pas choisies »). Un groupe VISIBLE à plusieurs valeurs sans pastille allumée est « à choisir » ;
     tant qu'il en reste un, pas d'identifiant de variante et pas d'ajout. Un groupe MASQUÉ (une
     conséquence, « Gamme » verrouillée) compte comme choisi : la fiche le pose elle-même. Le groupe d'une
     dimension rendue en deux axes (largeur, longueur) est masqué mais bien choisi par la personne. */
  function groupeAChoisir(j){
    var g=groups[j]; if(!g) return false;
    if(!g.__axes && !groupeFige(j)) return false;
    return g.querySelectorAll('.pill').length>1 && !g.querySelector('.pill.is-on');
  }
  function complet(){ for(var j=0;j<groups.length;j++){ if(groupeAChoisir(j)) return false; } return true; }
  /* le prix d'entrée de ce qui reste possible : « à partir de », jamais le prix d'une variante au hasard */
  function prixBornes(sel){
    var mn=null, mx=null;
    variants.filter(Boolean).forEach(function(v){
      for(var i=0;i<sel.length;i++){ if(sel[i]!=null && v['option'+(i+1)]!==sel[i]) return; }
      if(mn===null||v.price<mn) mn=v.price; if(mx===null||v.price>mx) mx=v.price;
    });
    return [mn, mx];
  }
  /* relâcher un choix : plus aucune pastille, le groupe redevient « à choisir » */
  function lacher(gi){
    var g=groups[gi]; if(!g) return;
    if(g.__lacherAxes){ g.__lacherAxes(); return; }
    g.querySelectorAll('.pill').forEach(function(p){ p.classList.remove('is-on'); });
    try{ g.dispatchEvent(new CustomEvent('lae:lacher')); }catch(e){}
  }

  /* 🛑 Une combinaison qui n'existe pas ne doit pas etre CLIQUABLE, et surtout
     pas retomber en silence sur une autre variante. Avant : `findVariant(sel)
     || variants[0]`. Sur le socle, « Benti — aluminium » + « 34 ou 37,5 cm »
     n'existe pas (le Benti est en 25 cm seulement) : la page affichait alors
     185 €, le prix du Socle Decor 90 cm, et le panier recevait CE socle-la.
     108 combinaisons etaient offertes par les boutons pour 61 variantes reelles
     — 47 culs-de-sac, dont aucun n'etait signale. */

  /* Une valeur est possible si au moins une variante la porte, TOUTES les autres
     selections etant respectees. */
  /* 🛑 Un groupe MASQUE (dont la valeur est une consequence, comme la hauteur du
     Benti) n'est pas une contrainte pour la personne : elle ne peut pas le
     changer, donc la fiche le change pour elle. Le compter comme fige rendait le
     Benti « conditionnel — dès 25 cm », une condition portant sur un bouton
     invisible. On l'ignore partout : disponibilite, raison, condition. */
  function groupeFige(j){
    var g=groups[j];
    return !(g && (g.hidden || (g.closest('.opt')||{}).hidden));
  }
  /* Les valeurs qu'on a masquees parce qu'elles sont des consequences : la
     personne ne peut pas les cliquer, donc la fiche a le droit de les poser
     elle-meme. Sans ca, le Benti restait « conditionnel — dès 25 cm », une
     condition portant sur un bouton qui n'existe plus a l'ecran. */
  function estMasquee(j, valeur){
    var g=groups[j]; if(!g) return false;
    var q=g.querySelector('.pill[data-val="'+String(valeur).replace(/"/g,'\\"')+'"]');
    return !!(q && q.hidden);
  }
  function possible(gi, val){
    var sel=selected();
    return variants.filter(Boolean).some(function(v){
      if(v['option'+(gi+1)]!==val) return false;
      for(var j=0;j<sel.length;j++){
        if(j===gi || sel[j]==null) continue;
        if(!groupeFige(j)) continue;              /* groupe masque : libre */
        if(v['option'+(j+1)]===sel[j]) continue;
        if(estMasquee(j, v['option'+(j+1)])) continue;   /* valeur non cliquable */
        return false;
      }
      return true;
    });
  }
  /* Apres un clic, on REPARE plutot que de bloquer : on garde le choix que la
     personne vient de faire et on deplace le minimum ailleurs pour retomber sur
     une variante reelle. Griser sans reparer obligerait a deviner quel autre
     bouton relacher. */
  function reparer(giFige){
    if(findVariant(selected())) return;
    var sel=selected(), j;
    /* 1. un groupe MASQUÉ est une conséquence : la fiche le pose elle-même, comme avant */
    for(j=groups.length-1;j>=0;j--){
      if(j===giFige || groupeFige(j) || groups[j].__axes) continue;
      var essai=sel.slice();
      var vals=[].slice.call(groups[j].querySelectorAll('.pill')).map(function(p){return p.getAttribute('data-val');});
      for(var k=0;k<vals.length;k++){
        essai[j]=vals[k];
        if(findVariant(essai)){ poser(j, vals[k]); return reparer(giFige); }
      }
    }
    /* 2. 🛑 30/09 : un choix VISIBLE devenu impossible est RELÂCHÉ (« à choisir »), jamais remplacé en
       silence par un autre — avant, choisir une matière changeait la largeur à votre place. */
    sel=selected();
    for(j=groups.length-1;j>=0;j--){
      if(j===giFige || sel[j]==null) continue;
      var e2=sel.slice(); e2[j]=null;
      if(findVariant(e2)){ lacher(j); return; }
    }
    for(j=0;j<groups.length;j++){ if(j!==giFige && (groupeFige(j) || groups[j].__axes)) lacher(j); }
  }
  function poser(gi, val){
    groups[gi].querySelectorAll('.pill').forEach(function(p){
      p.classList.toggle('is-on', p.getAttribute('data-val')===val); });
  }
  /* 🛑 Barrer un choix sans dire POURQUOI, c'est un mur. « 4 tiroirs » est barre
     sur un lit de 90 cm parce qu'il faut deux faces accessibles, donc 140 cm au
     moins — mais rien ne le disait, et la personne devait deviner quel autre
     bouton relacher. On calcule la raison : quelle autre valeur rendrait ce
     choix possible ? */
  /* La condition, en trois mots. `pourquoiPas` rend une phrase complete, utile
     dans la liste sous le groupe ; sur la pastille il faut tenir en une ligne.
     ⚠️ On prend le plus PETIT nombre des valeurs qui ouvrent le choix : « des
        140 cm » dit la regle, « 140, 150 ou 160 cm, 180 ou 200 cm » la recite. */
  function conditionCourte(gi, val){
    var sel=selected();
    for(var j=0;j<groups.length;j++){
      if(j===gi || !groupeFige(j)) continue;   /* un groupe masque n'est pas une raison */
      var ouvre=[];
      [].slice.call(groups[j].querySelectorAll('.pill')).forEach(function(q){
        var v=q.getAttribute('data-val');
        var ok=variants.filter(Boolean).some(function(x){
          if(x['option'+(gi+1)]!==val) return false;
          if(x['option'+(j+1)]!==v) return false;
          for(var k=0;k<sel.length;k++){ if(k!==gi && k!==j && sel[k]!=null && x['option'+(k+1)]!==sel[k]) return false; }
          return true;
        });
        if(ok) ouvre.push(v);
      });
      if(!ouvre.length) continue;
      var nombres=[];
      ouvre.forEach(function(v){ (v.match(/\d+/g)||[]).forEach(function(n){ nombres.push(parseInt(n,10)); }); });
      if(nombres.length) return 'dès ' + Math.min.apply(null, nombres) + ' cm';
      return ouvre[0].length>18 ? ouvre[0].slice(0,18)+'…' : ouvre[0];
    }
    return '';
  }
  function pourquoiPas(gi, val){
    var sel=selected();
    for(var j=0;j<groups.length;j++){
      if(j===gi || !groupeFige(j)) continue;   /* un groupe masque n'est pas une raison */
      var ouvre=[];
      [].slice.call(groups[j].querySelectorAll('.pill')).forEach(function(q){
        var v=q.getAttribute('data-val');
        var ok=variants.filter(Boolean).some(function(x){
          if(x['option'+(gi+1)]!==val) return false;
          if(x['option'+(j+1)]!==v) return false;
          for(var k=0;k<sel.length;k++){ if(k!==gi && k!==j && sel[k]!=null && x['option'+(k+1)]!==sel[k]) return false; }
          return true;
        });
        if(ok) ouvre.push(v);
      });
      if(ouvre.length){
        var nom=(groups[j].closest('.opt').querySelector('.k')||{}).textContent||'';
        return nom.trim().toLowerCase()+' : '+ouvre.join(', ');
      }
    }
    return null;
  }
  /* ─── Ce que chaque choix coute ──────────────────────────────────────────────
     🛑 « Le pire du pire : on n'a jamais le prix sur les variantes. »
        La fiche disait bien que le prix suivait — ou non — une dimension, mais
        jamais COMBIEN. Sur le socle, on choisissait entre trois bandes de
        largeur et douze types sans qu'aucun chiffre n'apparaisse avant le clic.

     Le prix d'un choix, c'est celui de la variante qu'on obtiendrait en le
     prenant, les autres choix inchanges. Quand cette combinaison n'existe pas
     (le catalogue Akva en interdit beaucoup), on affiche le prix le plus BAS
     atteignable avec cette valeur, precede de « des » — mieux vaut un ordre de
     grandeur juste qu'une pastille muette.

     ⚠️ On lit la vraie table `product.variants`, jamais un chiffre ecrit a la
        main : la fiche reste vraie quand le tarif change. */
  function prixDuChoix(gi, val){
    var sel=selected().slice();
    sel[gi]=val;
    var v=findVariant(sel);
    if(v) return {c:v.price, des:false};
    var cands=variants.filter(Boolean).filter(function(x){return x['option'+(gi+1)]===val;});
    if(!cands.length) return null;
    var mini=cands[0].price;
    cands.forEach(function(x){ if(x.price<mini) mini=x.price; });
    return {c:mini, des:true};
  }
  function etiqueterPrix(){
    groups.forEach(function(g,gi){
      /* Le groupe « Gamme » est masque (remise reservee aux lits Select) :
         l'etiqueter afficherait un prix que personne ne peut obtenir ici. */
      if(g.closest('.opt') && g.closest('.opt').hasAttribute('hidden')) return;
      g.querySelectorAll('.pill').forEach(function(p){
        var e=p.querySelector('[data-px]'); if(!e) return;
        var r=prixDuChoix(gi, p.getAttribute('data-val'));
        e.textContent = r ? ((r.des?'dès ':'')+money(r.c)) : '';
      });
    });
  }

  /* ─── Les valeurs qui ne sont pas des choix ──────────────────────────────────
     🛑 « 25 cm (Benti uniquement) » n'est pas une hauteur qu'on choisit : c'est
        la CONSEQUENCE d'avoir choisi le socle Benti. Presentee en bouton, elle
        garantissait la cascade absurde signalee par la cliente : on clique
        Benti, la hauteur bascule sur cette valeur, et TOUS les autres types
        deviennent alors impossibles — la fiche se barre elle-meme.

     On la reconnait sans la nommer : deux valeurs de deux groupes differents
     qui n'existent QUE l'une avec l'autre sont un seul et meme fait. On masque
     alors celle du groupe le plus a droite (la consequence) et on l'ENONCE. */
  var impliquees=[];
  (function reperer(){
    groups.forEach(function(g, gi){
      g.querySelectorAll('.pill').forEach(function(p){
        var val=p.getAttribute('data-val');
        var lot=variants.filter(Boolean).filter(function(x){return x['option'+(gi+1)]===val;});
        if(!lot.length) return;
        for(var j=0;j<gi;j++){
          var vs={}; lot.forEach(function(x){vs[x['option'+(j+1)]]=1;});
          var ks=Object.keys(vs);
          if(ks.length!==1) continue;
          var lotW=variants.filter(Boolean).filter(function(x){return x['option'+(j+1)]===ks[0];});
          var back={}; lotW.forEach(function(x){back[x['option'+(gi+1)]]=1;});
          if(Object.keys(back).length!==1) continue;
          p.hidden=true;
          impliquees.push({gi:gi, val:val, par:ks[0], groupe:g});
        }
      });
    });
  })();
  /* Quand la valeur retenue d'un groupe est une consequence, le groupe entier
     n'a plus rien a demander : on le remplace par une phrase. */
  function groupesImpliques(){
    groups.forEach(function(g, gi){
      var on=g.querySelector('.pill.is-on');
      var bloc=g.closest('.opt'); if(!bloc) return;
      var dit=bloc.querySelector('[data-implique-note]');
      var cache = !!(on && on.hidden);
      if(cache && !dit){
        dit=document.createElement('p'); dit.className='opt__why';
        dit.setAttribute('data-implique-note','');
        g.parentNode.insertBefore(dit, g.nextSibling);
      }
      if(dit){
        dit.hidden=!cache;
        if(cache){
          var e=document.createElement('span'); e.className='opt__whyl';
          e.textContent='Imposé par le choix précédent : ' + on.getAttribute('data-val');
          dit.textContent=''; dit.appendChild(e);
        }
      }
      g.hidden = cache;
    });
  }

  function marquerImpossibles(){
    /* 🛑 D'ABORD masquer les groupes-consequences, ENSUITE calculer les raisons.
       Dans l'autre ordre, les notes citaient un groupe qui allait disparaitre :
       « 7 choix — hauteur : 25 ou 30 cm » alors que la hauteur n'etait deja plus
       a l'ecran. Une explication qui renvoie a un bouton invisible. */
    groupesImpliques();
    groups.forEach(function(g,gi){
      /* un groupe masque n'a ni choix a griser ni raison a donner */
      if(!groupeFige(gi)){
        var nv=g.closest('.opt') && g.closest('.opt').querySelector('.opt__why:not([data-implique-note])');
        if(nv) nv.hidden=true;
        return;
      }
      var raisons=[];
      g.querySelectorAll('.pill').forEach(function(p){
        /* ⚠️ Une pastille MASQUEE (valeur-consequence) n'a pas a expliquer son
           indisponibilite : la note « 25 cm (Benti uniquement) — type : Socle
           Benti » parlait d'un bouton que personne ne voit. */
        if(p.hidden) return;
        var val=p.getAttribute('data-val');
        var ok=possible(gi, val);
        /* 🛑 Un choix qu'UN autre clic rend possible n'est pas indisponible :
           il est CONDITIONNEL. On ne le barre pas, on ecrit sa condition. */
        var r = ok ? null : pourquoiPas(gi, val);
        var conditionnel = !ok && !!r;
        p.classList.toggle('is-cond', conditionnel);
        p.classList.toggle('is-off', !ok && !conditionnel);
        var ce=p.querySelector('[data-cond]');
        if(ce) ce.textContent = conditionnel ? conditionCourte(gi, val) : '';
        /* Conditionnel = cliquable. Seul l'impossible est verrouille. */
        p.setAttribute('aria-disabled', (ok||conditionnel)?'false':'true');
        if(!ok){
          p.setAttribute('title', r? (val+' — '+r) : 'Cette combinaison n’existe pas au catalogue Akva');
          if(r) raisons.push(val+' — '+r);
        } else p.removeAttribute('title');
      });
      var note=g.parentNode.querySelector('[data-optwhy]');
      if(!note){ note=document.createElement('p'); note.className='opt__why';
                 note.setAttribute('data-optwhy',''); g.parentNode.appendChild(note); }
      /* ⚠️ Plusieurs valeurs partagent souvent la MÊME raison : « 4 tiroirs ·
         Décor — largeur : 140… · 4 tiroirs · Placage — largeur : 140… » disait
         deux fois la même chose. On regroupe par raison. */
      var parRaison={}, ordre=[];
      raisons.forEach(function(r){
        var i=r.indexOf(' — '); if(i<0) return;
        var val=r.slice(0,i), pourquoi=r.slice(i+3);
        if(!parRaison[pourquoi]){ parRaison[pourquoi]=[]; ordre.push(pourquoi); }
        parRaison[pourquoi].push(val);
      });
      /* 🛑 Les trois raisons etaient collees en UN paragraphe separe par des
         points medians. Sur le socle, ca donnait une dalle grise de trois
         lignes serrees ou l'oeil ne trouvait aucune entree — « design
         catastrophique », et c'etait vrai. Une raison = une ligne.
         ⚠️ Et au-dela de deux choix concernes, on les COMPTE au lieu de les
            nommer : « 4 grands tiroirs · Decor, 4 grands tiroirs · Placage,
            4 tiroirs · Decor, 4 tiroirs · Placage » disait quatre fois la meme
            chose pour une seule regle. */
      note.textContent = '';
      ordre.slice(0,3).forEach(function(p){
        var vals = parRaison[p];
        var qui = vals.length > 2 ? (vals.length + ' choix') : vals.join(' et ');
        var l = document.createElement('span');
        l.className = 'opt__whyl';
        l.textContent = qui + ' — ' + p;
        note.appendChild(l);
      });
      note.hidden = !ordre.length;
    });
    /* Le prix de chaque choix se recalcule au meme moment que le grisage : les
       deux dependent de la meme selection courante, et brancher ici evite
       d'oublier un des six points d'appel. */
    etiqueterPrix();
  }
  function refresh(){
    var sel=selected(); var v=findVariant(sel);
    if(!v){ marquerImpossibles(); return; }
    var ok=complet();
    /* 🛑 30/09 : incomplet, l'identifiant reste VIDE — même un envoi sans script ne commande pas la 1re variante */
    idEl.value = ok ? v.id : '';
    if(priceEl){
      if(ok) priceEl.textContent=money(v.price);
      else { var b=prixBornes(sel); priceEl.textContent = (b[0]!==null && b[0]!==b[1]) ? 'à partir de '+money(b[0]) : money(b[0]!==null?b[0]:v.price); }
    }
    if(cmpEl) cmpEl.innerHTML=(ok&&v.compare_at_price&&v.compare_at_price>v.price)?('<s>'+money(v.compare_at_price)+'</s>'):'';
    if(!ok || v.available){addEl.disabled=false;addEl.textContent='Ajouter au panier';}else{addEl.disabled=true;addEl.textContent='Indisponible';}
    /* 🛑 20/10 — LA PHOTO SUIT LE CHOIX DÈS LE PREMIER CLIC. Elle ne changeait qu'une fois TOUTES les options
       choisies : « Étroit 50 · Medium · 4 tiroirs » sans matière laissait la photo d'ouverture (2 tiroirs) — « t'as
       rien fait ». Incomplet, `v` est la 1re variante qui respecte les choix déjà faits (findVariant ignore les
       options vides) : on montre SA photo, dès qu'au moins une option est choisie. Sans aucun choix, la photo
       d'ouverture reste. (Le chercheur par texte alternatif, plus haut, se tait dès qu'une variante a sa photo.) */
    if(v.featured_media && v.featured_media.id && (ok || sel.some(function(x){ return x!=null; }))){ showMedia(v.featured_media.id); legenderMedia(v.featured_media.id); }
    groups.forEach(function(g,gi){var out=form.querySelector('[data-optout="'+gi+'"]');if(out){var on=g.querySelector('.pill.is-on');
      if(on){ out.textContent=on.getAttribute('data-val'); out.classList.remove('is-vide'); }
      else if(g.querySelectorAll('.pill').length>1){ out.textContent='à choisir'; out.classList.add('is-vide'); }  /* ⚠️ `textContent` collerait le nom de taille et le prix au libelle */}});
    choixMaj();
    supMaj(); coteMaj(); precMaj();
    /* la consequence de la hauteur depend aussi de « Avec / Sans tete » :
       elle se recalcule donc au meme endroit que le reste. */
    if(typeof shMaj === 'function') shMaj();
  }
  /* ── Une dimension, deux axes ────────────────────────────────────────────
     🛑 Onze fiches offraient UN SEUL groupe de 17 a 28 boutons
     (« 90*200 | 90*210 | 90*220 | 100*200 | … »). Ce n'est pas un choix, c'est
     une liste — et surtout elle CACHE la regle du tarif : le prix ne depend que
     de la LARGEUR (trois tranches), jamais de la longueur. La cliente a posé la
     question mot pour mot : « on ne comprend pas le fonctionnement des largeurs,
     toutes au même prix ou non ? »
     On garde la variante Shopify telle quelle — aucun identifiant ne bouge — et
     on rend le meme choix sur deux axes : largeur, puis longueur. Le groupe
     d'origine reste dans le DOM, masque, parce que `selected()` compte les
     groupes par index. */
  (function deuxAxes(){
    groups.forEach(function(g, gi){
      var vals=[].slice.call(g.querySelectorAll('.pill')).map(function(p){return p.getAttribute('data-val');});
      if(vals.length < 8) return;
      var paires=vals.map(function(v){var m=/^\s*(\d+)\s*[*x×]\s*(\d+)\s*$/.exec(v); return m?[m[1],m[2],v]:null;});
      if(paires.some(function(x){return !x;})) return;      /* toutes ou aucune */
      var L=[], H=[];
      paires.forEach(function(p){ if(L.indexOf(p[0])<0)L.push(p[0]); if(H.indexOf(p[1])<0)H.push(p[1]); });
      L.sort(function(a,b){return a-b;}); H.sort(function(a,b){return a-b;});
      if(L.length<2 || H.length<2) return;
      var bloc=g.closest('.opt');
      bloc.hidden=true;                                     /* on garde, on masque */
      var hote=document.createElement('div');
      hote.className='opt opt--axes';
      hote.innerHTML =
        '<p class="opt__lab"><span class="k">Largeur du lit</span> <b data-axe-out="L"></b></p>'+
        '<div class="opt__pills" data-axe="L">'+L.map(function(v){
          return '<button type="button" class="pill" data-axe-val="'+v+'">'+v+'&nbsp;cm<span class="pill__px" data-px></span></button>';}).join('')+'</div>'+
        '<p class="opt__lab opt__lab--2"><span class="k">Longueur</span> <b data-axe-out="H"></b></p>'+
        '<div class="opt__pills" data-axe="H">'+H.map(function(v){
          return '<button type="button" class="pill" data-axe-val="'+v+'">'+v+'&nbsp;cm<span class="pill__px" data-px></span></button>';}).join('')+'</div>'+
        '<p class="opt__why" data-axe-note></p>';
      bloc.parentNode.insertBefore(hote, bloc.nextSibling);

      /* 🛑 30/09 : aucun axe choisi d'avance. `courant()` rendait la PREMIÈRE dimension (90 × 200) quand
         rien n'était coché : la fiche commandait un 90 × 200 à qui n'avait rien choisi. Les deux axes
         vivent maintenant chacun leur vie ; la variante n'est posée que lorsque les deux sont choisis. */
      g.__axes = true; g.__hote = hote;
      function courant(){ var on=g.querySelector('.pill.is-on'); return on?on.getAttribute('data-val'):null; }
      var axL=null, axH=null;
      (function(){ var m=/^\s*(\d+)\s*[*x×]\s*(\d+)/.exec(courant()||''); if(m){ axL=m[1]; axH=m[2]; } })();
      function poserReel(l,h){
        var cible=paires.find(function(p){return p[0]===l && p[1]===h;});
        if(!cible) return false;
        g.querySelectorAll('.pill').forEach(function(p){ p.classList.toggle('is-on', p.getAttribute('data-val')===cible[2]); });
        return true;
      }
      function refletAxes(){
        [['L',axL],['H',axH]].forEach(function(pair){
          hote.querySelectorAll('[data-axe="'+pair[0]+'"] .pill').forEach(function(b){
            b.classList.toggle('is-on', b.getAttribute('data-axe-val')===pair[1]); });
          var o=hote.querySelector('[data-axe-out="'+pair[0]+'"]');
          if(o){ o.textContent = pair[1] ? pair[1]+' cm' : 'à choisir'; o.classList.toggle('is-vide', !pair[1]); }
        });
        /* la longueur impossible pour cette largeur est barrée, avec sa raison */
        var lg=axL, possibles=lg ? paires.filter(function(p){return p[0]===lg;}).map(function(p){return p[1];}) : null;
        var barres=[];
        hote.querySelectorAll('[data-axe="H"] .pill').forEach(function(b){
          var v=b.getAttribute('data-axe-val'), ok=!possibles || possibles.indexOf(v)>=0;
          b.classList.toggle('is-off', !ok);
          if(!ok) barres.push(v+' cm');
        });
        var n=hote.querySelector('[data-axe-note]');
        n.textContent = barres.length ? ('En '+lg+' cm de large, le catalogue Akva ne fait pas '+barres.join(', ')+'.') : '';
        n.hidden = !barres.length;
        prixAxes(axL, axH);
      }
      /* 🛑 Le prix aussi sur ces deux axes-la — c'est ici qu'il compte le plus.
         Le tarif ne fait varier le prix qu'avec la LARGEUR, jamais avec la
         longueur, et rien ne le montrait. Chaque largeur porte donc son prix,
         et chaque longueur montre qu'il ne bouge pas : la reponse a « toutes au
         meme prix ou non ? » devient visible sans lire une ligne. */
      function prixDeLa(dim){
        var v=variants.filter(Boolean).find(function(x){return x['option'+(gi+1)]===dim;});
        return v?v.price:null;
      }
      function prixAxes(lCur, hCur){
        hote.querySelectorAll('[data-axe="L"] .pill').forEach(function(b){
          var l=b.getAttribute('data-axe-val'), e=b.querySelector('[data-px]'); if(!e) return;
          var pr=paires.find(function(x){return x[0]===l && x[1]===hCur;});
          if(!pr){
            /* cette longueur n'existe pas dans cette largeur : on montre la
               moins chere atteignable plutot qu'une pastille muette */
            var ds=paires.filter(function(x){return x[0]===l;})
                         .map(function(x){return prixDeLa(x[2]);})
                         .filter(function(c){return c!=null;});
            e.textContent = ds.length ? ('dès '+money(Math.min.apply(null, ds))) : '';
            return;
          }
          var c=prixDeLa(pr[2]);
          e.textContent = c!=null ? money(c) : '';
        });
        hote.querySelectorAll('[data-axe="H"] .pill').forEach(function(b){
          var h=b.getAttribute('data-axe-val'), e=b.querySelector('[data-px]'); if(!e) return;
          var pr=paires.find(function(x){return x[0]===lCur && x[1]===h;});
          var c=pr?prixDeLa(pr[2]):null;
          e.textContent = c!=null ? money(c) : '';
        });
      }
      g.__lacherAxes = function(){ axL=null; axH=null; g.querySelectorAll('.pill').forEach(function(p){ p.classList.remove('is-on'); }); refletAxes(); };
      g.__axesVal = function(){ return [axL, axH]; };
      hote.querySelectorAll('.pill').forEach(function(b){
        b.addEventListener('click', function(){
          var axe=b.closest('[data-axe]').getAttribute('data-axe'), v=b.getAttribute('data-axe-val');
          if(axe==='L') axL=v; else axH=v;
          /* une largeur qui ne porte qu'une longueur : ce n'est pas un choix, la fiche la pose */
          if(axL && !axH){ var seules=paires.filter(function(p){return p[0]===axL;}); if(seules.length===1) axH=seules[0][1]; }
          /* la combinaison n'existe pas : on garde l'axe qu'on vient de toucher, l'autre redevient à choisir */
          if(axL && axH && !paires.some(function(p){return p[0]===axL && p[1]===axH;})){ if(axe==='L') axH=null; else axL=null; }
          if(axL && axH) poserReel(axL, axH);
          else g.querySelectorAll('.pill').forEach(function(p){ p.classList.remove('is-on'); });
          refresh(); refletAxes(); marquerImpossibles();
        });
      });
      refletAxes();
      g.__refletAxes = refletAxes;
    });
  })();

  groups.forEach(function(g,gi){g.querySelectorAll('.pill').forEach(function(pill){pill.addEventListener('click',function(){
    g.querySelectorAll('.pill').forEach(function(p){p.classList.remove('is-on');});
    pill.classList.add('is-on');
    reparer(gi);          /* on garde CE choix, on deplace les autres */
    refresh();
    marquerImpossibles();
  });});});
  marquerImpossibles();
  /* ── Les suppléments du tarif ───────────────────────────────────────────
     🛑 Le prix d'une option peut DEPENDRE de la variante : le nombre de boutons
        suit la largeur du lit (6/8/12 sur la K2, 9/15/21 sur la Mt. Thomas).
        L'etiquette et l'identifiant de variante se recalculent donc a chaque
        changement d'option — les figer vendrait 6 boutons pour un lit de 180.
     🛑 Surpiqures et boutons sont INCOMPATIBLES (tarif p.23 et p.24) : cocher
        l'un decoche et desactive l'autre. */
  var sup=root.querySelector('[data-sup]');
  var supL=sup?[].slice.call(sup.querySelectorAll('.sup__l')):[];
  function supMaj(){
    if(!sup) return;
    var sel=selected(), n=0, total=0;
    supL.forEach(function(l){
      var inp=l.querySelector('[data-sup-in]'), px=l.querySelector('[data-sup-px]');
      var selon=l.getAttribute('data-sup-selon');
      if(selon){
        /* on retrouve la valeur choisie pour l'option dont depend le prix */
        var gi=-1;
        groups.forEach(function(g,i){
          var k=(form.querySelector('[data-optout="'+i+'"]')||{}).closest;
          var lab=g.closest('.opt').querySelector('.k');
          if(lab && lab.textContent.trim()===selon) gi=i;
        });
        var cas={}; try{cas=JSON.parse(l.getAttribute('data-sup-cas'));}catch(e){}
        var c=gi>=0?cas[sel[gi]]:null;
        if(c){ inp.disabled=false; l.classList.remove('is-off');
               inp.setAttribute('data-vid',c.id); inp.setAttribute('data-cents',c.cents);
               px.textContent='+'+moneyCourt(c.cents)+(c.note?' · '+c.note:''); }
        else { inp.checked=false; inp.disabled=true; l.classList.add('is-off');
               px.textContent='indisponible dans cette taille'; }
      }
      if(inp.checked){ n++; total+=parseInt(inp.getAttribute('data-cents'),10)||0; }
    });
    /* exclusions mutuelles */
    supL.forEach(function(l){
      var ex=(l.getAttribute('data-sup-exclut')||'').split(',').filter(Boolean);
      if(!ex.length) return;
      var bloque=ex.some(function(c){
        var a=sup.querySelector('[data-sup-cle="'+c+'"] [data-sup-in]');
        return a && a.checked; });
      var inp=l.querySelector('[data-sup-in]');
      if(bloque){ inp.checked=false; inp.disabled=true; l.classList.add('is-off'); }
      else if(!l.getAttribute('data-sup-selon')){ inp.disabled=false; l.classList.remove('is-off'); }
    });
    var out=sup.querySelector('[data-sup-n]');
    if(out) out.textContent = n? (n+' supplément'+(n>1?'s':'')+' · +'+moneyCourt(total))
                              : 'aucun supplément';
  }
  /* ── LA COTE SUR MESURE ────────────────────────────────────────
     🛑 REFAIT LE 19/09/2026 SUR UNE ERREUR DE PRIX.
        Le tarif : « sur-mesure = +75 sur la dimension SUPERIEURE ». La première
        version ajoutait 75 € à la tranche que le client avait cochée. Sur le
        socle Décor 90/100/120 : 185 + 75 = **260 €** facturés là où la règle
        donne 268 + 75 = **343 €**. Quatre-vingt-trois euros, sur une ligne, et
        la même faute partout où une cote sur mesure était proposée.
     🛑 Et la présentation était la cause : « choisissez votre taille », puis
        plus bas « ou la taille que vous voulez ». Deux fois la même décision,
        sans lien entre elles — donc rien ne pouvait corriger la tranche.
     👉 La cote fixe désormais la tranche : elle sélectionne elle-même la valeur
        d'option qui couvre la cote demandée, donc la bonne variante, donc le bon
        prix de base. Et elle l'ÉCRIT à l'écran. */
  var cotB = [].slice.call(root.querySelectorAll('[data-cot]'));
  var cotEnCours = false;      /* 🛑 anti-boucle : cliquer une pastille rappelle refresh() */

  function cotNb(t){
    /* ⚠️ « 37,5 » s'écrit avec une virgule. `parseFloat('37,5')` rend 37 EN
       SILENCE : une cote fausse présentée comme valide. */
    t = String(t == null ? '' : t).trim().replace(',', '.').replace(/\s+/g, '');
    if (!t || !/^[0-9]+(\.[0-9]+)?$/.test(t)) return null;
    var n = parseFloat(t);
    return isNaN(n) ? null : n;
  }
  function cotFmt(n){ return String(n).replace('.', ','); }

  function cotBornes(inp, box){
    var min = parseFloat(inp.getAttribute('data-min'));
    var max = parseFloat(inp.getAttribute('data-max'));
    var cas = {};
    try { cas = JSON.parse(inp.getAttribute('data-cot-cas') || '{}'); } catch(e){}
    /* la borne peut dépendre d'une autre option : le socle miroir plafonne à
       37,5 quand les autres montent à 46, sa propre FAQ le dit. */
    for (var k in cas){
      if (!cas.hasOwnProperty(k)) continue;
      if (cotValeurOption(k) !== null) {
        var c = cas[k];
        if (c.min != null) min = parseFloat(c.min);
        if (c.max != null) max = parseFloat(c.max);
      }
    }
    return { min: min, max: max };
  }

  /* Le groupe d'options portant ce nom, et sa valeur courante. */
  function cotGroupe(nom){
    var g = null;
    root.querySelectorAll('.opt').forEach(function(o){
      var k = o.querySelector('.opt__lab .k');
      if (k && k.textContent.trim() === nom) g = o;
    });
    return g;
  }
  function cotValeurOption(v){
    var trouve = null;
    root.querySelectorAll('.opt .pill.is-on').forEach(function(p){
      if ((p.getAttribute('data-val') || '') === v) trouve = v;
    });
    return trouve;
  }

  function cotFaute(inp, box){
    var b = cotBornes(inp, box);
    var nom = inp.getAttribute('data-nom') || 'cette cote';
    var u = inp.getAttribute('data-unite') || 'cm';
    var pas = parseFloat(inp.getAttribute('data-pas')) || 1;
    var n = cotNb(inp.value);
    if (n === null) return 'Indiquez ' + nom.toLowerCase() + ' en ' + u + '.';
    if (n < b.min || n > b.max)
      return nom + ' : entre ' + cotFmt(b.min) + ' et ' + cotFmt(b.max) + ' ' + u + '.';
    var k = (n - b.min) / pas;
    if (Math.abs(k - Math.round(k)) > 1e-6)
      return nom + ' : par pas de ' + cotFmt(pas) + ' ' + u + '.';
    return null;
  }

  /* 🛑 LA REGLE DE PRIX. Les bandes sont TRIEES par taille croissante : la
     PREMIERE qui couvre toutes les cotes demandées est « la dimension
     supérieure » du tarif. Si aucune ne couvre — 46 cm sur un socle plafonné à
     37,5 — on prend la dernière et on le DIT : au-delà du standard, c'est la
     plus grande tranche qui sert de base. */
  function cotBande(box, vals){
    var bandes = [];
    try { bandes = JSON.parse(box.getAttribute('data-cot-bandes') || '[]'); } catch(e){}
    if (!bandes.length) return null;
    for (var i = 0; i < bandes.length; i++){
      var b = bandes[i], couvre = true;
      for (var j = 0; j < vals.length; j++){
        if (!(Number(b.jusqua[j]) >= vals[j])) { couvre = false; break; }
      }
      if (couvre) return { valeur: b.valeur, depasse: false };
    }
    return { valeur: bandes[bandes.length - 1].valeur, depasse: true };
  }

  function cotMsg(box, txt, inp){
    var e = box.querySelector('[data-cot-err]');
    if (!e) return;
    if (txt){ e.textContent = txt; e.hidden = false; if (inp) inp.setAttribute('aria-invalid','true'); }
    else { e.textContent=''; e.hidden = true;
           box.querySelectorAll('[data-cot-in]').forEach(function(i){ i.removeAttribute('aria-invalid'); }); }
  }

  function cotSup(box){
    var cle = box.getAttribute('data-cot-pour');
    var l = root.querySelector('[data-sup-cle="' + cle + '"]');
    return l ? l.querySelector('[data-sup-in]') : null;
  }

  /* Poser la cote : valider, choisir la tranche, la sélectionner, l'écrire. */
  function cotAppliquer(box){
    var champs = [].slice.call(box.querySelectorAll('[data-cot-in]'));
    var vals = [];
    for (var i = 0; i < champs.length; i++){
      var f = cotFaute(champs[i], box);
      if (f){ cotMsg(box, f, champs[i]); return false; }
      vals.push(cotNb(champs[i].value));
    }
    cotMsg(box, '');
    var px = box.querySelector('[data-cot-px]');
    var nom = box.getAttribute('data-cot-remplace');
    var bande = nom ? cotBande(box, vals) : null;

    if (bande){
      var g = cotGroupe(nom);
      var pill = g ? g.querySelector('.pill[data-val="' + bande.valeur.replace(/"/g,'\\"') + '"]') : null;
      if (pill && !pill.classList.contains('is-on')){
        cotEnCours = true;          /* 🛑 le clic rappelle refresh() -> coteMaj() */
        pill.click();
        cotEnCours = false;
      }
      if (g) g.querySelectorAll('.pill').forEach(function(p){
        p.classList.toggle('is-cote', p.getAttribute('data-val') === bande.valeur);
      });
      if (px){
        var dit = champs.map(function(c,i2){
          return cotFmt(vals[i2]) + ' ' + (c.getAttribute('data-unite') || 'cm');
        }).join(' × ');
        px.textContent = dit + ' — ' + (bande.depasse
          ? 'au-delà des tailles standard : tarifé sur la plus grande, «\u00a0'
          : 'tarifé sur la taille supérieure, «\u00a0')
          + bande.valeur + '\u00a0», supplément compris.';
        px.hidden = false;
      }
    } else if (px){
      /* pas de bande : le prix est plat (le Benti n'a pas d'option de hauteur) */
      px.textContent = champs.map(function(c,i2){
        return cotFmt(vals[i2]) + ' ' + (c.getAttribute('data-unite') || 'cm');
      }).join(' × ') + ' — supplément compris, sans changement de tarif de base.';
      px.hidden = false;
    }
    return true;
  }

  function cotMaj(){
    if (!cotB || cotEnCours) return;
    cotB.forEach(function(box){
      var on = box.hasAttribute('data-on');
      var corps = box.querySelector('.cot__corps');
      if (corps) corps.hidden = !on;
      box.querySelectorAll('[data-cot-in]').forEach(function(i){
        i.disabled = !on;
        var b = cotBornes(i, box), u = i.getAttribute('data-unite') || 'cm';
        var lab = i.closest('.cot__f').querySelector('[data-cot-borne]');
        if (lab) lab.textContent = 'de ' + cotFmt(b.min) + ' à ' + cotFmt(b.max) + ' ' + u;
      });
      /* la case cachée du panier suit l'état de la cote */
      var sup = cotSup(box);
      if (sup && sup.checked !== on){ sup.checked = on; sup.dispatchEvent(new Event('change', { bubbles:true })); }
      if (!on){
        cotMsg(box, '');
        var px = box.querySelector('[data-cot-px]'); if (px) px.hidden = true;
        root.querySelectorAll('.pill.is-cote').forEach(function(p){ p.classList.remove('is-cote'); });
      }
    });
  }

  cotB.forEach(function(box){
    var b = box.querySelector('[data-cot-bascule]');
    if (b) b.addEventListener('click', function(){
      var on = !box.hasAttribute('data-on');
      if (on) box.setAttribute('data-on',''); else box.removeAttribute('data-on');
      b.setAttribute('aria-expanded', on ? 'true' : 'false');
      cotMaj();
      if (on){ var i = box.querySelector('[data-cot-in]'); if (i) i.focus(); }
    });
    box.querySelectorAll('[data-cot-in]').forEach(function(i){
      /* contrôle au `blur` : corriger quelqu'un pendant qu'il tape est une
         brimade, et « 3 » est un début légitime de « 37,5 ». */
      i.addEventListener('blur', function(){ if (i.value) cotAppliquer(box); });
      i.addEventListener('input', function(){ cotMsg(box, ''); });
    });
  });

  /* Le contrôle d'ensemble, au moment d'ajouter. Rend le premier champ fautif. */
  function coteBloquant(){
    var mauvais = null;
    cotB.forEach(function(box){
      if (!box.hasAttribute('data-on') || mauvais) return;
      var champs = [].slice.call(box.querySelectorAll('[data-cot-in]'));
      for (var i = 0; i < champs.length; i++){
        var f = cotFaute(champs[i], box);
        if (f){ cotMsg(box, f, champs[i]); mauvais = champs[i]; return; }
      }
      cotAppliquer(box);
    });
    return mauvais;
  }
  /* compatibilité : l'ancien nom est encore appelé au `refresh()` */
  function coteMaj(){ cotMaj(); }

  function moneyCourt(c){var cur=((window.Shopify||{}).currency||{}).active||'EUR';
    var sym=cur==='EUR'?' €':(' '+cur);
    try{return (c/100).toLocaleString('fr-FR',{maximumFractionDigits:(c%100?2:0),
      minimumFractionDigits:(c%100?2:0)})+sym;}catch(e){return (c/100)+sym;}}
  /* ─── Le TOTAL de la commande ────────────────────────────────────────────────
     🛑 Le prix affiche est celui de la VARIANTE. Les suppléments partent en
        lignes separees au panier, donc ils ne l'affectent pas — et cocher
        « Façades rembourrees +320 € » laissait la fiche a 185 €. Elle ne mentait
        pas sur le produit, elle mentait sur ce qu'on allait payer.
     On additionne donc, et on le dit : la ligne n'apparait que si quelque chose
     est coche, et la barre collante montre le total, puisque c'est elle qui
     accompagne le bouton d'ajout. */
  var ligneTotal=root.querySelector('[data-total-ligne]');
  function centsVariante(){
    var sel=selected(), v=findVariant(sel);
    if(v && !complet()){ var b=prixBornes(sel); if(b[0]!==null) return b[0]; }   /* 30/09 : « à partir de » */
    return v?v.price:(variants.filter(Boolean)[0]||{price:0}).price;
  }
  function totalMaj(){
    var sup=0, n=0;
    supL.forEach(function(l){
      var c=l.querySelector('[data-sup-in]');
      /* ⚠️ Une option MASQUEE (elle ne s'applique pas a ce choix) peut rester
         cochee dans le DOM : la compter gonflerait un total que le panier ne
         verra jamais. */
      if(!c || !c.checked || l.hidden || c.disabled) return;
      sup += parseInt(c.getAttribute('data-cents')||'0',10)||0; n++;
    });
    var tot = centsVariante() + sup;
    if(ligneTotal){
      ligneTotal.hidden = (n===0);
      if(n) ligneTotal.innerHTML = 'avec ' + n + ' option' + (n>1?'s':'') +
        ' : <b>' + money(tot) + '</b>';
    }
    var bp2 = barreTotalEl();
    if(bp2) bp2.textContent = money(tot);
    var pb = root.querySelector('[data-px-bouton]');
    if(pb) pb.textContent = money(tot);
    return tot;
  }
  function barreTotalEl(){
    var b=document.getElementById('pp-barre-'+sid);
    return b? b.querySelector('[data-barre-prix]') : null;
  }
  supL.forEach(function(l){l.querySelector('[data-sup-in]').addEventListener('change',function(){
    supMaj(); coteMaj(); totalMaj(); });});
  supMaj(); coteMaj(); totalMaj();

  /* ── Les précisions de commande ─────────────────────────────────────────
     🛑 Certaines dependent d'une option : la LONGUEUR possible suit la largeur
        (200/210 sous 140 cm, jusqu'a 240 au-dela, p.32), la HAUTEUR EXACTE suit
        sa tranche de prix. D'autres ne concernent qu'un type : les cornieres
        alu n'existent que sur le socle plein en Decor. Les afficher toutes
        reviendrait a proposer des combinaisons que l'atelier ne fabrique pas. */
  /* ⚠️ Il y a desormais PLUSIEURS conteneurs `[data-prec]` : un sous chaque
     option qui gouverne une precision, plus celui du reste en bas. Lire au
     singulier n'en aurait vu qu'un — les autres seraient restes muets, sans
     erreur ni trace. */
  var precs=[].slice.call(root.querySelectorAll('[data-prec]'));
  var prec=precs[0]||null;
  var precL=[];
  precs.forEach(function(c){ precL=precL.concat([].slice.call(c.querySelectorAll('.prec__l'))); });
  function precMaj(){
    if(!precL.length) return;
    var sel=selected(), vus=0;
    precL.forEach(function(l){
      var montre=true;
      var typ=l.getAttribute('data-prec-type');
      if(typ){
        var liste=[]; try{liste=JSON.parse(typ);}catch(e){}
        montre = liste.some(function(v){ return sel.indexOf(v)>=0; });
      }
      var selon=l.getAttribute('data-prec-selon');
      if(montre && selon){
        var gi=-1;
        groups.forEach(function(g,i){
          var lab=g.closest('.opt').querySelector('.k');
          if(lab && lab.textContent.trim()===selon) gi=i;
        });
        var cas={}; try{cas=JSON.parse(l.getAttribute('data-prec-cas'));}catch(e){}
        var vals=gi>=0?cas[sel[gi]]:null;
        if(vals && vals.length){
          var s=l.querySelector('select'), garde=s.value;
          /* 30/09 : aucune précision cochée d'avance — « Choisissez » en tête dès qu'il y a un vrai choix */
          s.innerHTML=(vals.length>1?'<option value="">Choisissez</option>':'')+vals.map(function(v){return '<option value="'+v.replace(/"/g,'&quot;')+'">'+v+'</option>';}).join('');
          if(vals.indexOf(garde)>=0) s.value=garde; else if(vals.length>1) s.value='';
        } else montre=false;
      }
      l.hidden=!montre;
      l.querySelector('select').disabled=!montre;   /* sinon la propriete part quand meme */
      if(montre) vus++;
    });
    /* Chaque conteneur porte son propre compteur et se cache s'il est vide :
       un titre « A preciser » au-dessus de rien serait un cadre creux. */
    precs.forEach(function(c){
      var n=[].slice.call(c.querySelectorAll('.prec__l')).filter(function(l){return !l.hidden;}).length;
      var o=c.querySelector('[data-prec-n]');
      if(o) o.textContent = n? (n+' précision'+(n>1?'s':'')) : '';
      c.hidden = (n===0);
    });
  }
  precL.forEach(function(l){l.querySelector('select').addEventListener('change',function(){ precMaj(); choixMaj(); });});
  precMaj();

  /* ── LA HAUTEUR DE SOCLE ────────────────────────────────────────────────
     🛑 Demande du 22/09 : la fiche ANNONÇAIT trois hauteurs de socle (24, 28,
        32 cm sur Emma) et n'en proposait aucune. Le cadre ET sa tete de lit
        sont fabriques a cette hauteur — elle fixe la hauteur de couchage et
        celle de la tete — mais Shopify plafonne a trois options de variante et
        les trois sont prises. La hauteur voyage donc en PROPRIETE DE LIGNE,
        comme la teinte des tetes de lit.
     ⚠️ Les deux selects vivent HORS de tout conteneur `[data-prec]` : sinon
        `precL` les ajouterait une SECONDE fois au panier, et la commande
        porterait la propriete en double. Ils gardent un `name="properties[…]"`
        pour survivre au repli en POST classique quand l'AJAX echoue. */
  var shBox=root.querySelector('[data-sh]');
  var shIn=shBox?shBox.querySelector('[data-sh-in]'):null;
  var shSer=shBox?shBox.querySelector('[data-sh-serie-in]'):null;
  var shOut=shBox?shBox.querySelector('[data-sh-out]'):null;
  var shErr=shBox?shBox.querySelector('[data-sh-err]'):null;
  var shCas={};
  if(shBox){ try{ shCas=JSON.parse(shBox.getAttribute('data-sh-cas')||'{}')||{}; }catch(e){ shCas={}; } }
  function shSerie(){ return shSer ? shSer.value : (Object.keys(shCas)[0]||''); }
  function shTable(){ var k=shSerie(); return (k && shCas[k]) ? shCas[k] : []; }
  /* 🛑 La liste des hauteurs SUIT la serie : rendue une fois pour toutes, elle
     proposerait encore 40 cm a qui a choisi Hardside, qui s'arrete a 36 (p.20).
     Meme contrat que les precisions du socle, en plus simple : ici la table
     entiere est deja dans l'attribut, il n'y a rien a aller chercher. */
  function shRemplir(){
    if(!shIn || !shSer) return;
    var garde=shIn.value, L=shTable(), html='';
    html='<option value="">'+(L.length?'Choisissez une hauteur':'Choisissez d’abord le matelas prévu')+'</option>';
    L.forEach(function(r){ html+='<option value="'+r[0]+'">'+r[0]+'</option>'; });
    shIn.innerHTML=html;
    var tenu=false; L.forEach(function(r){ if(r[0]===garde) tenu=true; });
    shIn.value = tenu ? garde : '';
  }
  /* Ce que le choix CHANGE, en toutes lettres : « 28 cm » seul ne dit rien a
     qui achete un lit, la hauteur de couchage et celle de la tete, si.
     ⚠️ La hauteur de tete n'est annoncee QUE si la variante en a une : sur
        « Sans tete », ce serait une cote imaginaire. */
  function shMaj(){
    if(!shBox || !shIn) return;
    var L=shTable(), v=shIn.value, ligne=null;
    L.forEach(function(r){ if(r[0]===v) ligne=r; });
    if(!ligne){ if(shOut) shOut.textContent=''; return; }
    var sansTete=false;
    selected().forEach(function(x){ if(x && /sans\s*t[eê]te/i.test(x)) sansTete=true; });
    var txt='Socle '+ligne[0]+' → couchage '+ligne[1];
    if(!sansTete) txt+=' · tête de lit '+ligne[2];
    if(shOut) shOut.textContent=txt;
    if(shErr){ shErr.hidden=true; shErr.textContent=''; }
  }
  /* 🛑 Le meme principe que `coteBloquant` (19/09) : laisser passer la commande
     sans la hauteur, c'est vendre une fabrication qu'on ne sait pas decrire.
     Aucune valeur n'est cochee d'avance — une mediane pre-selectionnee
     engagerait la cliente sur un choix qu'elle n'a pas fait. */
  function shBloquant(){
    if(!shBox) return null;
    var manque=null, msg='';
    if(shSer && !shSer.value){
      manque=shSer; msg='Choisissez le matelas à eau prévu : c’est lui qui décide des hauteurs de socle possibles.';
    } else if(shIn && !shIn.value){
      manque=shIn; msg='Choisissez la hauteur de socle : c’est elle qui fixe la hauteur à laquelle le cadre et sa tête de lit sont fabriqués.';
    }
    if(shErr){ shErr.textContent=msg; shErr.hidden=!manque; }
    return manque;
  }
  if(shSer) shSer.addEventListener('change',function(){
    shRemplir(); shMaj();
    /* on efface le reproche des que la cliente agit ; il ne revient qu'au
       prochain essai d'ajout */
    if(shErr){ shErr.hidden=true; shErr.textContent=''; }
  });
  if(shIn) shIn.addEventListener('change',function(){ shMaj(); if(shErr){ shErr.hidden=true; shErr.textContent=''; } });
  shRemplir(); shMaj();

  /* ── LA BARRE D'ACHAT AU DOIGT ──────────────────────────────────────────
     🛑 Mesure au telephone : sur le socle, le bouton d'achat tombe a 3,4 ecrans
     de defilement, et le prix n'y est PLUS VISIBLE — alors que le socle va de
     185 a 1538 € selon les choix. On choisissait a l'aveugle.
     ⚠️ `IntersectionObserver` plutot qu'un `scroll` : le navigateur nous
        previent quand le vrai bouton entre ou sort du champ, sans recalculer a
        chaque pixel. Un `scroll` sur un telephone modeste coute cher. */
  var barre=document.getElementById('pp-barre-'+sid);
  var vrai=document.getElementById('pp-add-'+sid);
  if(barre && vrai){
    var bp=barre.querySelector('[data-barre-prix]');
    var px=form.querySelector('[data-price]');
    /* le prix de la barre suit celui de la fiche, quelle que soit la cause du
       changement (variante, reparation d'une combinaison impossible…) */
    if(px && bp && window.MutationObserver){
      /* ⚠️ Le miroir recopiait le prix de la VARIANTE : il ecrasait le total
         des qu'une option etait cochee. Il passe donc par `totalMaj`, qui
         retombe sur le prix seul quand rien n'est coche. */
      new MutationObserver(function(){
        if(typeof totalMaj === 'function') totalMaj(); else bp.textContent=px.textContent; })
        .observe(px,{childList:true,characterData:true,subtree:true});
      bp.textContent=px.textContent;
    }
    if(window.IntersectionObserver){
      new IntersectionObserver(function(e){
        var dehors = !e[0].isIntersecting;
        barre.hidden = !dehors;
        barre.classList.toggle('is-on', dehors);
        /* rendre au contenu la hauteur que la barre lui prend */
        document.body.classList.toggle('a-barre-achat', dehors);
      },{threshold:0}).observe(vrai);
    }
  }

  /* ── CE QUI MANQUE ENCORE ──────────────────────────────────────────────
     🛑 30/09 : « on ne doit pas pouvoir commander si toutes les options ne sont pas choisies ». On liste,
        dans l'ordre de la page : les options, les précisions visibles, la teinte ou le tissu. Le message
        est porté par un role="alert" (annoncé, pas seulement coloré), chaque manque est entouré, et on
        rend le premier pour y amener la personne. `annoncer` = seulement au clic sur « Ajouter » ; ensuite
        le message se réduit au fil des choix, et disparaît quand il n'y a plus rien. */
  var errChoix=document.getElementById('pp-err-'+sid);
  function listeFr(a){ return a.length<2 ? a.join('') : a.slice(0,-1).join(', ')+' et '+a[a.length-1]; }
  function choixBloquant(annoncer){
    var manques=[], premier=null;
    root.querySelectorAll('.opt--manque').forEach(function(e){ e.classList.remove('opt--manque'); });
    groups.forEach(function(g, j){
      if(!groupeAChoisir(j)) return;
      if(g.__axes && g.__hote){
        var av=g.__axesVal ? g.__axesVal() : [null,null];
        [['L','largeur'],['H','longueur']].forEach(function(x, k){
          if(av[k]) return;
          manques.push(x[1]);
          var pills=g.__hote.querySelector('[data-axe="'+x[0]+'"]');
          if(pills){ g.__hote.classList.add('opt--manque'); if(!premier) premier=pills.querySelector('.pill:not(.is-off)'); }
        });
        return;
      }
      var o=g.closest('.opt'), k=o && o.querySelector('.opt__lab .k');
      manques.push(k ? k.textContent.trim().toLowerCase() : 'une option');
      if(o) o.classList.add('opt--manque');
      if(!premier) premier=g.querySelector('.pill:not([disabled]):not(.is-off)') || g.querySelector('.pill');
    });
    (precL||[]).forEach(function(l){
      var s=l.querySelector('select'); if(!s || l.hidden || s.disabled || s.value) return;
      var t=l.querySelector('.prec__t'); manques.push(t ? t.textContent.trim().toLowerCase() : 'une précision');
      l.classList.add('opt--manque'); if(!premier) premier=s;
    });
    var col=root.querySelector('[data-coloris]');
    if(col){
      var inp=col.querySelector('[data-teinte-in]');
      var vis=[].slice.call(col.querySelectorAll('[data-fam]:not([hidden]) .lc__s'));
      if(inp && !inp.value && vis.length){
        var kk=col.querySelector('.lc__lab .k'); manques.push(kk ? kk.textContent.trim().toLowerCase() : 'teinte');
        col.classList.add('opt--manque'); if(!premier) premier=vis[0];
      }
    }
    if(errChoix && (annoncer || !errChoix.hidden)){
      errChoix.textContent = manques.length ? 'Pour commander, il reste à choisir : '+listeFr(manques)+'.' : '';
      errChoix.hidden = !manques.length;
    }
    if(!annoncer && errChoix && errChoix.hidden) root.querySelectorAll('.opt--manque').forEach(function(e){ e.classList.remove('opt--manque'); });
    return premier;
  }
  /* après chaque choix : le reproche se réduit — il ne s'affiche pas avant le premier essai d'ajout */
  function choixMaj(){ if(errChoix && !errChoix.hidden) choixBloquant(false); }
  form.addEventListener('click', function(e){ if(e.target.closest && e.target.closest('.lc__s')) setTimeout(choixMaj, 0); });

  /* ── 06/10 — AU TÉLÉPHONE, LA BARRE DIT LA PROCHAINE ACTION ──────────────────
     Refonte mobile (mobile-banc/SYSTEME-MOBILE.md §4-5) : la barre collante affichait « 884,00 € · Ajouter »
     alors que la largeur du cadre restait à choisir ; le toucher ne faisait que remonter au premier manque.
     La barre du matelas, elle, dit « Choisir la largeur ». Même règle ici : tant qu'un choix manque, le
     bouton le NOMME (« Choisir la largeur », « Choisir la finition »…), puis redevient « Ajouter » ; et tant
     que la fiche affiche un prix d'entrée (« à partir de »), la barre porte la classe `is-des` — le « dès »
     est écrit par lae-mobile-produits. Le toucher fait toujours la même chose : mener au premier manque.
     🛑 Garde `matchMedia('(max-width:749px)')`, qui réagit au changement : à l'ordinateur, libellé
        d'origine et aucune classe — le chemin ne change pas. Si l'écran s'élargit, on rend l'origine.
     ⚠️ Lecture SANS effet de bord : `choixBloquant` entoure les manques et écrit le message d'alerte ;
        ici on ne fait que chercher le premier, dans l'ordre de l'envoi (options, précisions, teinte,
        cote du sur-mesure, puis matelas prévu et hauteur de socle).
     ⚠️ Pendant l'ajout (`disabled`, puis « Ajouté » / `is-done` 2,4 s) on ne touche à rien : le
        libellé d'origine est rendu par l'envoi lui-même. */
  var barreBtn = barre ? barre.querySelector('button[type=submit]') : null;
  var barreLib0 = barreBtn ? barreBtn.textContent : '';
  var barreTouchee = false;
  var mqTel = window.matchMedia ? window.matchMedia('(max-width:749px)') : null;
  /* l'article du nom d'option : « la largeur », « le coloris », « l’épaisseur », « les pieds » */
  function articleFr(n){
    n = (n || '').trim().toLowerCase(); if(!n) return '';
    var m1 = n.split(/[\s’']/)[0];
    if(/^[aeiouyàâéèêëîïôûœ]/.test(m1)) return 'l’' + n;
    var masc = ['modèle','modele','coloris','tissu','matelas','type','format','socle','revêtement','pied','plateau','bois',
      'cadre','côté','sens','nombre','volume','kit','lot','conditionnement','diamètre','choix','support','tiroir','cuir',
      'contenu','parfum','produit','système','motif','fond','dessin','poids','prix','pack','set','montage','raccord',
      'chauffage','thermostat','drap','protège','oreiller','coussin','tapis','traitement','flacon','bidon','modèle'];
    var sing = ['matelas','coloris','bois','choix','poids','prix','sens','tapis'];
    if(/s$|x$/.test(m1) && sing.indexOf(m1) < 0) return 'les ' + n;
    return (masc.indexOf(m1) >= 0 ? 'le ' : 'la ') + n;
  }
  function premierManque(){
    for(var j=0;j<groups.length;j++){
      if(!groupeAChoisir(j)) continue;
      var g=groups[j];
      if(g.__axes && g.__hote){
        var av=g.__axesVal ? g.__axesVal() : [null,null];
        if(!av[0]) return 'Choisir la largeur';
        if(!av[1]) return 'Choisir la longueur';
        continue;
      }
      var o=g.closest('.opt'), k=o && o.querySelector('.opt__lab .k');
      return 'Choisir ' + (k ? articleFr(k.textContent) : 'une option');
    }
    for(var i=0;i<(precL||[]).length;i++){
      var l=precL[i], s=l.querySelector('select');
      if(!s || l.hidden || s.disabled || s.value) continue;
      var t=l.querySelector('.prec__t'), tn=t && t.firstChild && t.firstChild.nodeType===3 ? t.firstChild.textContent : (t ? t.textContent : '');
      return 'Choisir ' + (tn.trim() ? articleFr(tn) : 'une précision');
    }
    var col=root.querySelector('[data-coloris]');
    if(col){
      var inp=col.querySelector('[data-teinte-in]');
      if(inp && !inp.value && col.querySelector('[data-fam]:not([hidden]) .lc__s')){
        var kk=col.querySelector('.lc__lab .k'); return 'Choisir ' + (kk ? articleFr(kk.textContent) : 'la teinte');
      }
    }
    var cv=null;
    (typeof cotB!=='undefined' ? cotB : []).forEach(function(box){
      if(cv || !box.hasAttribute('data-on')) return;
      [].forEach.call(box.querySelectorAll('[data-cot-in]'), function(c){ if(!cv && !String(c.value).trim()) cv='Indiquer la cote'; });
    });
    if(cv) return cv;
    if(shBox){
      if(shSer && !shSer.value) return 'Choisir le matelas prévu';
      if(shIn && !shIn.value) return 'Choisir la hauteur de socle';
    }
    return null;
  }
  function barreDire(){
    if(!barreBtn || barreBtn.disabled || barreBtn.classList.contains('is-done')) return;
    var tel = !!(mqTel && mqTel.matches);
    if(!tel){
      /* ordinateur : on ne rend l'origine que si le téléphone l'avait changée */
      if(barreTouchee){ barreBtn.textContent = barreLib0; barre.classList.remove('is-des'); barreTouchee = false; }
      return;
    }
    var lib = premierManque() || barreLib0;
    if(barreBtn.textContent !== lib) barreBtn.textContent = lib;
    var des = !!(priceEl && /^\s*à partir de/i.test(priceEl.textContent));
    if(barre.classList.contains('is-des') !== des) barre.classList.toggle('is-des', des);
    barreTouchee = true;
  }
  if(barreBtn){
    /* après chaque geste de la fiche : les écouteurs des pastilles, sélecteurs et nuancier ont déjà agi */
    root.addEventListener('click', function(){ setTimeout(barreDire, 0); });
    root.addEventListener('change', function(){ setTimeout(barreDire, 0); });
    if(mqTel){ if(mqTel.addEventListener) mqTel.addEventListener('change', barreDire); else if(mqTel.addListener) mqTel.addListener(barreDire); }
  }

  // qty
  var qi=form.querySelector('input[name=quantity]');
  form.querySelectorAll('[data-q]').forEach(function(btn){btn.addEventListener('click',function(){var n=Math.max(1,(parseInt(qi.value,10)||1)+parseInt(btn.getAttribute('data-q'),10));qi.value=n;});});
  // add ajax
  /* tous les boutons qui ajoutent : le vrai, et celui de la barre au doigt */
  var boutons=[addEl].concat(barre?[].slice.call(barre.querySelectorAll('button[type=submit]')):[])
                     .filter(Boolean);
  var enCours=false;
  form.addEventListener('submit',function(e){e.preventDefault();if(addEl.disabled)return;
    /* 🛑 Une cote cochée mais vide ou hors bornes BLOQUE l'ajout. C'est le
       coeur de la correction du 19/09 : laisser passer la commande sans la
       cote, c'est vendre une fabrication qu'on ne sait pas décrire — et le
       client ne l'apprendrait qu'au coup de téléphone de l'atelier.
       ⚠️ Le contrôle passe AVANT `enCours`, sinon un refus laisserait le
          bouton verrouillé jusqu'au rechargement. */
    /* 🛑 30/09 : un choix manquant (option, précision, teinte ou tissu) BLOQUE l'ajout — et le dit */
    var manqueChoix = choixBloquant(true);
    if(manqueChoix){
      try{ manqueChoix.scrollIntoView({block:'center', behavior:'smooth'}); }catch(err){}
      try{ manqueChoix.focus({preventScroll:true}); }catch(err){ manqueChoix.focus(); }
      return;
    }
    var mauvais = (typeof coteBloquant==='function') ? coteBloquant() : null;
    if(mauvais){
      try{ mauvais.scrollIntoView({block:'center', behavior:'smooth'}); }catch(err){}
      mauvais.focus();
      return;
    }
    /* 🛑 Meme regle pour la hauteur de socle : sans elle, l'atelier ne sait pas
       a quelle hauteur fabriquer le cadre ni sa tete de lit. Le message est
       porte par un `role="alert"`, donc annonce, pas seulement colore. */
    var manqueSocle = (typeof shBloquant === 'function') ? shBloquant() : null;
    if(manqueSocle){
      try{ manqueSocle.scrollIntoView({block:'center', behavior:'smooth'}); }catch(err){}
      manqueSocle.focus();
      return;
    }
    /* 🛑 19/10 — la référence du revêtement (snippets/lae-renseignement.liquid) : sans la date de l'étiquette du
       dessous, ni le numéro S du dessus, ni la case « je ne trouve pas » cochée, l'ajout est REFUSÉ et le dit
       sous le champ — commander un dessus sans pouvoir vérifier la fermeture, c'est risquer un retour. */
    var rens = root.querySelector('[data-rens]');
    if(rens){
      var rIn = rens.querySelector('[data-rens-in]'), rSans = rens.querySelector('[data-rens-sans]'), rErr = rens.querySelector('[data-rens-err]');
      var rVide = (rIn.value||'').trim().length < 4 && !(rSans && rSans.checked);
      if(rErr) rErr.hidden = !rVide;
      rens.classList.toggle('opt--manque', rVide);
      if(rVide){
        try{ rIn.scrollIntoView({block:'center', behavior:'smooth'}); }catch(err){}
        rIn.focus();
        return;
      }
    }
    /* 🛑 verrou : deux tapes pendant la requete ajoutaient DEUX lignes */
    if(enCours)return; enCours=true;
    boutons.forEach(function(b){b.disabled=true;});
    var fd=new FormData(form);
    /* 🛑 Les suppléments partent en LIGNES SEPAREES, comme sur le bon de commande
       Akva : le client voit ce qu'il paie, et une option peut etre retiree du
       panier sans defaire le produit. `/cart/add.js` accepte un tableau `items`
       en JSON — la forme FormData, elle, n'envoie qu'une seule ligne. */
    var lignes=[{id:parseInt(idEl.value,10), quantity:parseInt(qi.value,10)||1, properties:{}}];
    var teinte=form.querySelector('[data-teinte-in]');
    if(teinte && teinte.value) lignes[0].properties['Teinte']=teinte.value;
    /* la hauteur de socle voyage comme la teinte ; la serie de matelas ne part
       que lorsqu'elle a servi a determiner les hauteurs (Nori) */
    if(shIn && shIn.value){
      lignes[0].properties['Hauteur de socle']=shIn.value;
      if(shSer && shSer.value) lignes[0].properties['Matelas prévu']=shSer.value;
    }
    /* les précisions visibles voyagent avec la ligne, comme la teinte */
    precL.forEach(function(l){
      if(l.hidden) return;
      var s=l.querySelector('select');
      var nom=(s.getAttribute('name')||'').replace(/^properties\[|\]$/g,'');
      if(nom && s.value) lignes[0].properties[nom]=s.value;
    });
    /* la référence du revêtement voyage sur la ligne, comme la teinte — ou la mention « non fournie » acceptée */
    if(rens){
      var rIn2 = rens.querySelector('[data-rens-in]'), rSans2 = rens.querySelector('[data-rens-sans]');
      lignes[0].properties[rens.getAttribute('data-rens-nom')] =
        (rSans2 && rSans2.checked) ? rens.getAttribute('data-rens-sans-valeur') : rIn2.value.trim();
    }
    /* Les deux branches etaient choisies par Liquid sur les TAGS du produit ; elles
       le sont maintenant sur `data-pp-algicide` (« matelas » | « ensemble » | vide)
       et `data-pp-poches`, poses par la section avec les memes conditions. */
    if(algicide==='matelas'){
    /* ── ALGICIDE OFFERT ─────────────────────────────────────────────────────
       Regle Sommum Wellness (11/09) : un conditionneur Akva Long Life offert PAR
       POCHE. 🛑 On l'ecrit sur la LIGNE DE COMMANDE et pas seulement dans la
       description : une mention dans la fiche n'arrive jamais jusqu'a celui qui
       prepare le colis. Meme traitement que sur le configurateur des lits.
       ⚠️ Un matelas Softside = UNE poche, meme quand la fiche dit « Duo » : un
       80x200 est la MOITIE d'un lit 160. Seule la formule « Dual » du Hardside en
       vaut deux, et elle se lit sur le libelle de la VARIANTE choisie — pas sur le
       titre du produit, ou « Duo » veut dire autre chose. */
    var vAlg = variants.filter(function(x){ return x.id === parseInt(idEl.value, 10); })[0] || {};
    lignes[0].properties['Conditionneur offert'] =
      (/dual/i.test(vAlg.title || '') ? 2 : 1) + ' x Akva Long Life 380 ml';
    } else if(algicide==='ensemble'){
    /* Meme regle sur les lits VENDUS TOUT CONFIGURES. Ils n'ont qu'une variante et
       aucun selecteur : le nombre de poches est donc fixe et connu du produit, on le
       lit sur son tag `duo` / `mono` plutot que sur un libelle de variante. */
    lignes[0].properties['Conditionneur offert'] = poches + ' x Akva Long Life 380 ml';
    }
    supL.forEach(function(l){
      var i=l.querySelector('[data-sup-in]');
      if(!(i && i.checked && !i.disabled)) return;
      /* 🛑 Le NOM du produit, pas le titre de l'onglet : celui-ci est le titre
         SEO, et le panier affichait « … dès 1 » (coupe a 60 caracteres). */
      var props={'Pour':titre};
      /* 🛑 La cote voyage sur la ligne du SUPPLÉMENT, pas sur celle du produit :
         c'est cette ligne-là que l'atelier lit pour fabriquer. La poser sur le
         produit l'aurait séparée de ce qu'elle décrit. */
      /* ⚠️ La cote n'est plus voisine du supplément : elle vit dans le groupe
         de taille qu'elle remplace. On la retrouve par sa clef, pas par sa
         position — une recherche par voisinage aurait rendu `null` en silence,
         et la commande serait partie SANS la cote qu'elle facture. */
      var cle=l.getAttribute('data-sup-cle');
      var box=root.querySelector('[data-cot][data-cot-pour="'+cle+'"]');
      if(box && box.hasAttribute('data-on')){
        box.querySelectorAll('[data-cot-in]').forEach(function(c){
          var n=cotNb(c.value);
          if(n===null) return;
          props[c.getAttribute('data-nom')] = cotFmt(n)+' '+(c.getAttribute('data-unite')||'cm');
        });
        /* la tranche retenue part AUSSI : c'est elle qui explique le prix */
        var px=box.querySelector('[data-cot-px]');
        if(px && !px.hidden) props['Tarification'] = px.textContent.replace(/\s+/g,' ').trim().slice(0,140);
      }
      lignes.push({id:parseInt(i.getAttribute('data-vid'),10), quantity:1, properties:props});
    });
    if(!lignes[0].properties || !Object.keys(lignes[0].properties).length) delete lignes[0].properties;
    /* 23/09 : `sections` fait rendre l'icone du panier par Shopify dans la meme
       reponse — c'est elle que `laePanier` pose (cf. assets/cart-notification.js). */
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
                          body:JSON.stringify({items:lignes, sections:'cart-icon-bubble', sections_url:window.location.pathname})}).then(function(r){if(!r.ok)throw 0;return r.json();}).then(function(rep){
      var anciens=boutons.map(function(b){return b.textContent;});
      boutons.forEach(function(b,i){
        b.classList.add('is-done');
        /* la barre est etroite : « Ajoute » y suffit, la fiche dit la phrase entiere */
        b.textContent = (b===addEl) ? 'Ajouté au panier' : 'Ajouté';
      });
      /* 🛑 23/09 — LA PASTILLE RESTAIT ABSENTE. On ecrivait `item_count` dans
         `.cart-count-bubble span`, que le theme ne rend pas quand le panier est
         vide : au premier ajout (et aux suivants, l'element n'existant toujours
         pas) rien ne bougeait avant la page suivante. `laePanier` fait re-rendre
         l'icone, publie `cartUpdate` et montre la confirmation legere.
         Le nom annonce est celui du PRODUIT (1re ligne), pas d'un supplement. */
      if(window.laePanier){
        window.laePanier.apresAjout(rep);
      } else {
        fetch('/cart.js').then(function(r){return r.json();}).then(function(c){document.querySelectorAll('#cart-icon-bubble .cart-count-bubble span[aria-hidden]').forEach(function(s){s.textContent=c.item_count;});});
      }
      setTimeout(function(){
        boutons.forEach(function(b,i){b.classList.remove('is-done');b.textContent=anciens[i];b.disabled=false;});
        enCours=false;
      },2400);
    }).catch(function(){
      /* ⚠️ on relache AVANT de retomber sur l'envoi classique, sinon un echec
         reseau laisserait les deux boutons morts jusqu'au rechargement. */
      enCours=false; boutons.forEach(function(b){b.disabled=false;});
      form.submit();
    });
  });
  /* 🛑 20/10 — DÉCOR PAR DÉFAUT, à SA demande (« mets Décor par défaut ») : exception NOMINATIVE à « rien n'est
     choisi d'avance » (30/09), limitée aux trois meubles qui ont une matière Décor. Choisir le modèle donne alors
     tout de suite une variante complète (prix, photo du bon modèle). On passe par un VRAI clic : prix, photo,
     grisage et barre se mettent à jour par le chemin habituel. Si la matière est déjà posée (lien vers une
     variante), on n'y touche pas. Toutes les autres fiches gardent « rien d'avance ». */
  (function(){
    var DEFAUTS = { 'commode-akva': 'Decor', 'table-de-chevet-au-sol-akva': 'Décor', 'table-de-chevet-suspendue-akva': 'Décor' };
    var h = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
    var val = h && DEFAUTS[decodeURIComponent(h)];
    if(!val) return;
    groups.forEach(function(g){ var q = g.querySelector('.pill[data-val="'+val+'"]'); if(q && !g.querySelector('.pill.is-on')) q.click(); });
  })();
  refresh();
  /* 06/10 — au téléphone, la barre nomme d'emblée le premier choix à faire (voir « LA BARRE DIT LA PROCHAINE ACTION ») */
  if(typeof barreDire==='function') barreDire();
  }
  function tout(){
    [].forEach.call(document.querySelectorAll('[data-pp-sid]'), function(sec){
      if(sec.__ppPret) return;
      sec.__ppPret = true;
      try { initPremium(sec); } catch(e) { if(window.console) console.error('litaeau-product-premium', e); }
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', tout); else tout();
  /* l'editeur de theme recharge une section sans recharger la page */
  document.addEventListener('shopify:section:load', tout);
})();
